import React, { useEffect, useState, Component } from 'react';
import { Zap } from 'lucide-react';
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}
function setCookie(name: string, value: string, maxAge: number) {
  document.cookie = `${name}=${encodeURIComponent(value)};max-age=${maxAge};path=/`;
}
function getOrCreateExpiry(): number {
  const existing = getCookie('vvm_countdown_expiry');
  if (existing) {
    const ts = parseInt(existing, 10);
    if (!isNaN(ts)) return ts;
  }
  const expiry = Date.now() + 24 * 60 * 60 * 1000;
  setCookie('vvm_countdown_expiry', String(expiry), 86400);
  return expiry;
}
function formatTime(ms: number): {
  hours: string;
  minutes: string;
  seconds: string;
} {
  if (ms <= 0) return {
    hours: '00',
    minutes: '00',
    seconds: '00'
  };
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };
}
export function CountdownBanner() {
  const [remaining, setRemaining] = useState<number>(() => {
    const expiry = getOrCreateExpiry();
    return Math.max(0, expiry - Date.now());
  });
  useEffect(() => {
    const expiry = getOrCreateExpiry();
    const interval = setInterval(() => {
      const diff = Math.max(0, expiry - Date.now());
      setRemaining(diff);
      if (diff <= 0) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const expired = remaining <= 0;
  const {
    hours,
    minutes,
    seconds
  } = formatTime(remaining);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={scrollToPricing} className="fixed top-0 left-0 right-0 z-50 bg-yellow-400 cursor-pointer animate-banner-pulse" data-id="element-110">
      <div className="max-w-4xl mx-auto px-4 py-2.5 text-center" data-id="element-111">
        {/* Headline */}
        <div className="flex items-center justify-center gap-2" data-id="element-112">
          <Zap className="w-5 h-5 text-red-600 fill-red-600 flex-shrink-0" data-id="element-113" />
          <span className="text-red-600 font-extrabold text-sm md:text-base tracking-tight" data-id="element-114">
            🔥 ESPECIAL DE HOY SOLAMENTE $6.39! 🔥
          </span>
          <Zap className="w-5 h-5 text-red-600 fill-red-600 flex-shrink-0" data-id="element-115" />
        </div>

        {/* Subtext with countdown */}
        <div className="animate-subtext-fade mt-1" data-id="element-116">
          {expired ? <span className="text-red-700 font-bold text-xs md:text-sm" data-id="element-117">
              ⏰ ¡Tiempo Agotado! Precio vuelve a $27
            </span> : <span className="text-red-700 font-bold text-xs md:text-sm" data-id="element-118">
              Precio Vuelve A $27 En ⏰{' '}
              <span className="font-mono" style={{
            fontVariantNumeric: 'tabular-nums'
          }} data-id="element-119">
                {hours}:{minutes}:{seconds}
              </span>
            </span>}
        </div>
      </div>
    </div>;
}